import PageCategories from './page';
import CategoryForm from './form';

export {
  CategoryForm,
};

export default PageCategories;
